var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2497 10.2426L11.0071 6",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0069 10.2496L15.2495 6.00699",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1884 11.0426L8.18239 14.3275C8.50863 14.5959 9 14.3638 9 13.9414V3.04688C9 2.62649 8.51272 2.39376 8.18574 2.65799L4.18749 5.8889C4.09853 5.96079 3.98761 6 3.87323 6H1.5C1.22386 6 1 6.22386 1 6.5V10.4288C1 10.7049 1.22386 10.9288 1.5 10.9288H3.8708C3.98666 10.9288 4.09892 10.969 4.1884 11.0426Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiet);
export default __webpack_public_path__ + "static/media/quiet.8c0d77cfa1babdc82544b6c1f548ec33.svg";
export { ForwardRef as ReactComponent };